import type { Ref, TextareaHTMLAttributes } from 'react';

/**
 * A text area — design-system plan DS-5 (F42, F125, F84). Twelve were written raw with the text box's class; this is
 * that box, several lines tall, resizable up and down only (a sideways drag breaks the form's grid). `mono` is for
 * text that is code, not prose: a PEM key, a pasted CSV.
 */
export function Textarea({
  mono,
  className,
  ref,
  ...props
}: TextareaHTMLAttributes<HTMLTextAreaElement> & { mono?: boolean; ref?: Ref<HTMLTextAreaElement> }) {
  const classes = ['wb-input', 'wb-textarea', mono ? 'wb-textarea--mono' : '', className ?? ''].filter(Boolean).join(' ');
  return <textarea rows={3} {...props} ref={ref} className={classes} />;
}
Textarea.wbLabellable = true;
